<template>
    <div>
        <Block v-if="loading" />
        <v-card flat class="bar">
            <v-row class="pa-4">
                <v-col col="6" class="mt-3" >
                    <div class="d-flex">
                    <v-checkbox
                        v-model="optionSameDate"
                        single-line
                        class="me-3"
                        @change="setDateFrom(dateFrom)"
                    >
                    <template v-slot:label>
                        <span style="color: #FFF;" class="text-white">Misma fecha</span>
                    </template>
                    </v-checkbox>
                    <v-btn
                            class="btn-save mr-2 me-3"
                            small
                            @click="addDay()"
                        >
                        +1 día
                    </v-btn>
                    <v-btn
                            class="btn-save mr-1"
                            small
                            @click="minusDay()"
                        >
                        -1 día
                    </v-btn>
                    </div>
                </v-col>
                <v-col col="6" class="mt-3">
                    <div class="d-flex justify-end">
                        <v-btn
                            class="btn-save mr-1"
                            small
                            @click="validateUnassignedElements"
                        >
                            Ver Movimientos
                        
                        </v-btn>
                        <v-btn
                            class="btn-save mr-1"
                            small
                            @click="processDetailsBeforeInit"
                        >
                            Contabilizar
                        
                        </v-btn>
                        
                    </div>
                </v-col>
            </v-row>
        </v-card>
        <v-row class="mt-5 ml-2 d-flex justify-start">
            <v-col cols="12" md="6">
                <DatePicker
                    label="Desde"
                    v-model="dateFrom"
                    :value="dateFrom"
                    @dateSelected="setDateFrom"
                />
            </v-col>
            <v-col cols="12" md="6">
                <DatePicker
                    dense
                    label="Hasta"
                    v-model="dateTo"
                    :value="dateTo"
                    @dateSelected="(param) => (dateTo = param)"
                />
            </v-col>
        </v-row>
        <!-- <v-row class="ml-2"> -->
        <v-radio-group row v-model="type" class="ml-9 d-flex justify-center">
            <v-col md="2">
            </v-col>
            <v-col cols="12" md="4">
                <v-radio
                    label="Realizar una partida por operación"
                    :value="2"
                ></v-radio>
            </v-col>
            <v-col cols="12" md="4">
                <v-radio
                    label="Realizar una partida por movimiento"
                    :value="1"
                ></v-radio>
            </v-col>
            <v-col md="2">
            </v-col>
        </v-radio-group>
            <!-- <v-col cols="12" md="12" class="">
                <v-checkbox
                    label="Consolidar movimientos en una sola partida por operación"
                    :value="false"
                ></v-checkbox>
            </v-col> -->
        <!-- </v-row> -->
        <v-row class="mt-2 ml-2 d-flex justify-start">
            <v-col cols="12" md="3">
                <v-checkbox
                    v-model="form.sales.value"
                    single-line
                >
                    <template v-slot:label>
                        <span class="text-h5">Ventas</span>
                    </template>
                </v-checkbox>
            </v-col>
        </v-row>
        <v-expand-transition>
            <div v-if="form.sales.value">
                <v-radio-group v-model="form.sales.sales2" row class="ml-9" :disabled="!form.sales.value">
                    <v-col cols="12" md="6">
                        <v-radio
                        label="Consolidar ventas por estado de la factura (Contado/Crédito)"
                        :value="true"
                        ></v-radio>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-radio
                            label="Consolidar ventas por método de pago"
                            :value="false"
                        ></v-radio>
                    </v-col>
                </v-radio-group>
                <v-radio-group v-model="form.sales.sales3" row class="ml-9" :disabled="!form.sales.value">
                    <v-col cols="12" md="6">
                        <v-radio
                            label="Contabilizar Costo de Ventas"
                            :value="true"
                        ></v-radio>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-radio
                            label="No Contabilizar Costo de Ventas"
                            :value="false"
                        ></v-radio>
                    </v-col>
                </v-radio-group>
                <v-radio-group v-model="form.sales.sales4" row class="ml-9" :disabled="!form.sales.value">
                    <v-col cols="12" md="4">
                        <v-radio
                            label="Contabilizar Créditos según Parametrización General"
                            :value="1"
                        ></v-radio>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-radio
                            label="Contabilizar Créditos según las cuentas respectivas del cliente"
                            :value="2"
                        >
                        </v-radio>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-radio
                            label="Contabilizar Créditos según las cuentas de rubro"
                            :value="3"
                        >
                        </v-radio>
                    </v-col>
                </v-radio-group>
                <v-row  class="ml-9">
                    <v-col>
                        <v-checkbox
                            v-model="form.sales.returns"
                            label="Contabilizar devoluciones"
                            :disabled="!form.sales.value"
                        >
                        </v-checkbox>
                    </v-col>
                    <v-col>
                        <v-checkbox
                            v-model="form.sales.joinSalesMovements"
                            label="Contabilizar abonos y devoluciones junto con la partida de ventas"
                            :disabled="!form.sales.value"
                        >
                        </v-checkbox>
                    </v-col>
                </v-row>
                <v-expand-transition>
                    <v-row v-if="type === 1" class="ml-9">
                        <v-col>
                            <v-checkbox
                                v-model="concatCustomerLegalName"
                                label="Concatenar nombre legal del cliente en la descripcion"
                            >
                            </v-checkbox>
                        </v-col>
                    </v-row>
                </v-expand-transition>
            </div>
        </v-expand-transition>
        <v-row class="mt-2 ml-2 d-flex justify-start">
            <v-col cols="12" md="3">
                <v-checkbox
                    v-model="form.payments.value"
                    single-line
                >
                    <template v-slot:label>
                        <span class="text-h5">Abonos</span>
                    </template>
                </v-checkbox>
            </v-col>
        </v-row>
        <v-expand-transition>
            <div v-if="form.payments.value">
                <v-radio-group v-model="form.payments.groupByPaymentMethods" row class="ml-9" :disabled="!form.payments.value">
                    <v-col cols="12" md="6">
                        <v-radio
                            label="Contabilizar mediante Métodos de Pago"
                            :value="true"
                        ></v-radio>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-radio
                            label="Contabilizar solo cómo Ingresos por Abonos"
                            :value="false"
                        ></v-radio>
                    </v-col>
                </v-radio-group>
                <v-radio-group v-model="form.payments.creditsAdditionStyle" row class="ml-9" :disabled="!form.payments.value">
                    <v-col cols="12" md="6">
                        <v-radio
                            label="Contabilizar Créditos según Parametrización General"
                            :value="true"
                        ></v-radio>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-radio
                            label="Contabilizar Créditos según las cuentas respectivas del cliente"
                            :value="false"
                        ></v-radio>
                    </v-col>
                </v-radio-group>
            </div>
        </v-expand-transition>
        <v-row class="mt-2 ml-2 d-flex justify-start">
            <v-col cols="12" md="3">
                <v-checkbox
                    v-model="form.purchases.value"
                    single-line
                >
                    <template v-slot:label>
                        <span class="text-h5">Provisiones</span>
                    </template>
                </v-checkbox>
            </v-col>
        </v-row>
        <v-expand-transition>
            <div v-if="form.purchases.value">
                <v-row  class="ml-9">
                    <v-col md="6">
                        <v-autocomplete
                            v-model="form.purchases.dateFilterType"
                            label ="Tipo de Filtro por Fecha"
                            item-text="text"
                            item-value="value"
                            :items="dateFilterTypes"
                            attach
                        />
                    </v-col>
                </v-row>
                <v-row  class="ml-9">
                    <v-col md="6">
                        <v-checkbox
                            v-model="form.purchases.includeCosts"
                            label="Costos"
                            :disabled="!form.purchases.value"
                        >
                        </v-checkbox>
                    </v-col>
                    <v-col md="6">
                        <v-checkbox
                            v-model="form.purchases.includeExpenses"
                            label="Gastos"
                            :disabled="!form.purchases.value"
                        >
                        </v-checkbox>
                    </v-col>
                </v-row>
                <v-radio-group  v-model="form.purchases.groupPayments" row class="ml-9" :disabled="!form.purchases.value">
                    <v-col cols="12" md="6">
                        <v-radio
                            label="Consolidar pagos en cuentas de Parametrización General"
                            :value="true"
                        ></v-radio>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-radio
                            label="Consolidar pagos en cuentas respectivas del proveedor"
                            :value="false"
                        ></v-radio>
                    </v-col>
                </v-radio-group>
                <v-row  class="ml-9">
                    <v-col>
                        <v-checkbox
                            v-model="form.purchases.concatInvoice"
                            label="Incluir correlativos del documento y separar por movimiento."
                            :disabled="!form.purchases.value"
                        >
                        </v-checkbox>
                    </v-col>
                    <v-col>
                        <v-checkbox
                            v-if="form.purchases.concatInvoice && !form.purchases.groupPayments"
                            v-model="form.purchases.concatProviderName"
                            label="Incluir el nombre del proveedor al conceptos"
                            :disabled="!form.purchases.value"
                        >
                        </v-checkbox>
                    </v-col>
                </v-row>
                <v-row  class="ml-9">
                    <v-col>
                        <v-checkbox
                            v-model="form.purchases.includePaid"
                            label="Incluir facturas de contado"
                            :disabled="!form.purchases.value"
                        >
                        </v-checkbox>
                    </v-col>
                    <v-col>
                        <v-checkbox
                            v-model="form.purchases.includeCredit"
                            label="Incluir facturas Pendientes de Pago o a Crédito"
                            :disabled="!form.purchases.value"
                        >
                        </v-checkbox>
                    </v-col>
                </v-row>
                <v-row class="ml-9">
                    <v-col>
                        <v-checkbox
                            v-model="form.purchases.separateFns"
                            label="Separar FNS"
                            :disabled="!form.purchases.value"
                        >
                        </v-checkbox>
                    </v-col>
                </v-row>
            </div>
        </v-expand-transition>
        <v-row class="mt-2 ml-2 d-flex justify-start">
            <v-col cols="12" md="3">
                <v-checkbox
                    v-model="form.provitionsPayments.value"
                    single-line
                >
                    <template v-slot:label>
                        <span class="text-h5">Abonos a Proveedores</span>
                    </template>
                </v-checkbox>
            </v-col>
        </v-row>
        <v-expand-transition>
            <div v-if="form.provitionsPayments.value">
                <!-- <v-radio-group v-model="form.provitionsPayments.groupByPaymentMethods" row class="ml-9" :disabled="!form.provitionsPayments.value">
                    <v-col cols="12" md="6">
                        <v-radio
                            label="Contabilizar mediante Métodos de Pago"
                            :value="true"
                        ></v-radio>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-radio
                            label="Contabilizar solo cómo Ingresos por Abonos"
                            :value="false"
                        ></v-radio>
                    </v-col>
                </v-radio-group> -->
                <v-radio-group v-model="form.provitionsPayments.creditsAdditionStyle" row class="ml-9" :disabled="!form.provitionsPayments.value">
                    <v-col cols="12" md="6">
                        <v-radio
                            label="Contabilizar Créditos según Parametrización General"
                            :value="true"
                        ></v-radio>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-radio
                            label="Contabilizar Créditos según las cuentas respectivas del proveedor"
                            :value="false"
                        ></v-radio>
                    </v-col>
                </v-radio-group>
            </div>
        </v-expand-transition>
        <v-row class="mt-2 ml-2 d-flex justify-start">
            <v-col cols="12" md="3">
                <v-checkbox
                    v-model="form.settlement.value"
                    single-line
                >
                    <template v-slot:label>
                        <span class="text-h5">Cierre</span>
                    </template>
                </v-checkbox>
            </v-col>
        </v-row>
        <v-expand-transition>
            <div v-if="form.settlement.value">
                <v-row>
                    <v-col md="3" class="ml-9">
                        <v-select v-model="form.settlement.year" :items="validYears" item-text="Year" item-value="Year" label="Año" outlined
                                attach dense></v-select>
                    </v-col>
                </v-row>
                <v-row  class="ml-9">
                    <v-col md="6">
                        <v-checkbox
                            v-model="form.settlement.includeOI"
                            label="Incluir Ingresos Operacionales"
                            :disabled="!form.settlement.value"
                        >
                        </v-checkbox>
                    </v-col>
                    <v-col md="6">
                        <v-checkbox
                            v-model="form.settlement.includeANOI"
                            label="Incluir Ingresos no Operacionales"
                            :disabled="!form.settlement.value"
                        >
                        </v-checkbox>
                    </v-col>
                </v-row>
                <v-row  class="ml-9">
                    <v-col>
                        <v-checkbox
                            v-model="form.settlement.includeCRAS"
                            label="Incluir, Costos, Devoluciones y Rebajas Sobre Ventas"
                            :disabled="!form.settlement.value"
                        >
                        </v-checkbox>
                    </v-col>
                    <v-col>
                        <v-checkbox
                            v-model="form.settlement.includeSpents"
                            label="Incluir Gastos"
                            :disabled="!form.settlement.value"
                        >
                        </v-checkbox>
                    </v-col>
                </v-row>
            </div>
        </v-expand-transition>
        <DxDataGrid v-if="submittedType === 1" :dataSource="DataTable" :showBorders="true" :scrolling="{ useNative: true }" :column-auto-width="true" @exporting="onExporting">
            <DxExport :enabled="true" />
            <DxPager showPageSizeSelector="true" allowedPageSizes="[5, 10, 20]" />
            <DxPaging defaultPageSize="5" />
            <DxColumn :group-index="0" data-field="Op" caption="Operación"></DxColumn>
            <DxColumn :group-index="1" data-field="ID_Invoice" caption="ID del Documento"></DxColumn>
            <DxColumn data-field="account_code" caption="Cuenta Contable" :width="300"></DxColumn>
            <DxColumn data-field="account_description" caption="Concepto"></DxColumn>
            <!-- <DxColumn data-field="Deber" caption="Deber"></DxColumn>
            <DxColumn data-field="Haber" caption="Haber"></DxColumn> -->
            <DxColumn data-field="Deber" cell-template="debit-template" caption="Deber"></DxColumn>
            <DxColumn data-field="Haber" cell-template="credit-template" caption="Haber"></DxColumn>
            <template #debit-template="{ data }">
                {{ formatedMoneyFieldFromChild( 'Deber', data.data ) }}
            </template>
            <template #credit-template="{ data }">
                {{ formatedMoneyFieldFromChild( 'Haber', data.data ) }}
            </template>
        </DxDataGrid>
        <DxDataGrid class="grid-invisible" :dataSource="DataTable" :showBorders="true" :scrolling="{ useNative: true }" :column-auto-width="true" @exporting="onExporting" ref="hiddentable">
            <DxExport :enabled="true" />
            <DxPager showPageSizeSelector="true" allowedPageSizes="[5, 10, 20]" />
            <DxPaging defaultPageSize="5" />
            <DxColumn :group-index="0" data-field="Op" caption="Operación"></DxColumn>
            <DxColumn :group-index="1" data-field="ID_Invoice" caption="ID del Documento"></DxColumn>
            <DxColumn data-field="account_code" caption="Cuenta Contable"></DxColumn>
            <DxColumn data-field="accountDescription1" caption=""></DxColumn>
            <DxColumn data-field="accountDescription2" caption="Documento"></DxColumn>
            <DxColumn data-field="accountDescription3" caption="Cliente"></DxColumn>
            <!-- <DxColumn data-field="Deber" caption="Deber"></DxColumn>
            <DxColumn data-field="Haber" caption="Haber"></DxColumn> -->
            <DxColumn data-field="Deber" cell-template="debit-template" caption="Deber"></DxColumn>
            <DxColumn data-field="Haber" cell-template="credit-template" caption="Haber"></DxColumn>
            <template #debit-template="{ data }">
                {{ formatedMoneyFieldFromChild( 'Deber', data.data ) }}
            </template>
            <template #credit-template="{ data }">
                {{ formatedMoneyFieldFromChild( 'Haber', data.data ) }}
            </template>
        </DxDataGrid>
        <DxDataGrid v-if="submittedType === 2" :dataSource="DataTable" :showBorders="true" :scrolling="{ useNative: true }" :column-auto-width="true" @exporting="onExporting">
            <DxExport :enabled="true" />
            <DxPager showPageSizeSelector="true" allowedPageSizes="[5, 10, 20]" />
            <DxPaging defaultPageSize="5" />
            <DxColumn :group-index="0" data-field="Op" caption="Operación"></DxColumn>
            <!-- <DxColumn :group-index="1" data-field="ID" caption="ID del Documento"></DxColumn> -->
            <DxColumn data-field="account_code" caption="Cuenta Contable"></DxColumn>
            <DxColumn data-field="account_description" caption="Concepto"></DxColumn>
            <!-- <DxColumn data-field="Deber" caption="Deber"></DxColumn>
            <DxColumn data-field="Haber" caption="Haber"></DxColumn> -->
            <DxColumn data-field="Deber" cell-template="debit-template" caption="Deber"></DxColumn>
            <DxColumn data-field="Haber" cell-template="credit-template" caption="Haber"></DxColumn>
            <template #debit-template="{ data }">
                {{ formatedMoneyFieldFromChild( 'Deber', data.data ) }}
            </template>
            <template #credit-template="{ data }">
                {{ formatedMoneyFieldFromChild( 'Haber', data.data ) }}
            </template>
        </DxDataGrid>
        <!-- <v-row class="mt-5">
        </v-row> -->

        <v-row class="ml-2">
            <v-col cols="12" md="4">
                <v-card-title> Total de Débitos: {{ formatedMoneyField( 'TotalDebits' ) }} </v-card-title>
            </v-col>
            <v-col cols="12" md="4">
                <v-card-title> Total de Créditos: {{ formatedMoneyField( 'TotalCredits' ) }} </v-card-title>
            </v-col>
            <v-col cols="12" md="4">
                <v-card-title v-if="diff == 0 || diff == '0.00'">
                    Diferencia: {{ formatedMoneyField( 'diff' ) }}
                </v-card-title>
                <v-card-title v-else style="color: red">
                    Diferencia: {{ formatedMoneyField( 'diff', this ) }}
                </v-card-title>
            </v-col>
        </v-row>
        <alerts
            v-if="alert.show"
            v-on:close_alert="closeAlert"
            v-on:accept_alert="acceptAlert"
            :properties="alert"
        />

    </div>
</template>

<script>
    
    //import {mapState} from 'vuex';
    import DatePicker from "@/components/DatePicker";
    import {
        DxDataGrid,
        DxPager,
        DxPaging,
        DxColumn,
        DxExport
    } from 'devextreme-vue/data-grid';
    import { convertDateFormat2 } from "@/helpers/formatDate"
    import Block from '@/components/Block.vue';
    import Alerts from '@/components/Alerts.vue';
import { numberWithCommas } from "../../../helpers/money";
import { onlyUnique } from "../../../helpers/object";
import { printToExcel } from '@/helpers/printToexcel'

    export default {
        name: "AcountAutomaticDetail",
        components: {
            DxDataGrid,
            DxPager,
            DxPaging,
            DxColumn,
            Block,
            Alerts,
            DatePicker,
            DxExport
        },
        props: ['win'],
        data() {
            return {
                Currency: JSON.parse(localStorage.getItem("branch")).Currency,
                keyMaster: JSON.parse(localStorage.getItem("user")).keymaster,
                type: 2,
                submittedType: 2,
                concatCustomerLegalName: false,
                DataTable: [],
                panel: 0,
                tab: null,
                key: 0,
                loading: false,
                alert: {
                    type: "success",
                    show: false,
                    header: "",
                    body: "",
                },
                dateFilterTypes: [
                    {
                        text: 'Filtrar movimientos por fecha del documento',
                        value: 1
                    },
                    {
                        text: 'Filtrar movimientos por fecha de registro en sistema',
                        value: 2
                    }
                ],
                form: {
                    sales: {
                        value: false,
                        sales2: true,
                        sales3: true,
                        sales4: 1,
                        returns: false,
                        joinSalesMovements: false
                    },
                    purchases: {
                        value: false,
                        includeCosts: false,
                        includeExpenses: false,
                        groupPayments: true,
                        concatInvoice: false,
                        includePaid: false,
                        includeCredit: false,
                        dateFilterType: 1,
                        concatProviderName: false,
                        separateFns: false
                    },
                    payments: {
                        value: false,
                        groupByPaymentMethods: true,
                        creditsAdditionStyle: false
                    },
                    provitionsPayments: {
                        value: false,
                        groupByPaymentMethods: true,
                        creditsAdditionStyle: false
                    },
                    cost: false,
                    settlement: {
                        year: new Date().getFullYear(),
                        value: false,
                        includeOI: false,
                        includeANOI: false,
                        includeCRAS: false,
                        includeSpents: false
                    }
                },
                dateTo: null,
                dateFrom: null,
                formatConfig: {
                    char: '/',
                    dayIndex: 0,
                    monthIndex: 1,
                    yearIndex: 2
                },
                targetFormat: "yyyy-mm-dd",
                accounting_entry_types: {
                    'Ventas, Devoluciones y Abonos': 4,
                    'Provisión de Compras ( Costos )': 1,
                    'Provisión de Compras ( Gastos )': 1,
                    'Sujeto Excluido ( Costos )': 1,
                    'Sujeto Excluido ( Gastos )': 1,
                    'Costo de Ventas': 1,
                    'Venta': 4,
                    'Abono': 4,
                    'Devolucion': 4,
                    'Cierre': 10,
                    'Abono a Proveedores': 3
                },
                optionSameDate: false,
                validYears: [],
                executionIds: []
            }
        },
        computed:{
            TotalDebits() {
                let returnValue = 0;

                for( const element of this.DataTable ) {
                    returnValue += element.Deber;
                }

                return returnValue;
            },
            TotalCredits() {
                let returnValue = 0;

                for( const element of this.DataTable ) {
                    returnValue += element.Haber;
                }

                return returnValue;
            },
            diff() {
                return ( parseFloat( this.TotalDebits ) - parseFloat( this.TotalCredits ) ).toFixed( 2 );
            },
            isPoliclinica(){
                return this.keyMaster == 'fa6646a6d6ef0c5f347a240270f49f38';
            },
            isTecana(){
                return this.keyMaster == '47770e9a83f6f46af2a3d2b93fff710a';
            }
        },
        watch: {
            "form.purchases.value"( value ) {
                if( value && !this.form.purchases.includeCosts && !this.form.purchases.includeExpenses ) {
                    this.form.purchases.includeCosts = true;
                }
            }
        },
        mounted() {

            // this.dateTo = this.moment().format("DD/MM/YYYY");
            // this.dateFrom = this.moment().format("DD/MM/YYYY");
            this.initialConfig();
            this.getValidYears();
        },
        methods: {
            async getValidYears() {
                try {
                    const { data: validYearsResponse } = await this.$API.accountingentryheader.getAcountingHeaderValidYears();
                    this.validYears = validYearsResponse;
                } catch (error) {
                    console.log( "Error al obtener los años con movimientos contables: ", error );
                }
            },
            onExporting(e) {
                console.log('Exportando...');
                if (this.type === 1 && this.concatCustomerLegalName) {
                    printToExcel({ component: this.$refs.hiddentable.$el.__vue__?.$_instance }, 'Partidas Automáticas');
                    return;
                }
                printToExcel(e, 'Partidas Automáticas');
            },
            addDay(){
                this.dateFrom = this.getOneDay(this.dateFrom);
                this.dateTo = this.getOneDay(this.dateTo);
            },
            minusDay(){
                this.dateFrom = this.getOneDay(this.dateFrom, -1);
                this.dateTo = this.getOneDay(this.dateTo, -1);
            },
            getOneDay(dateParam, op = 1){
                const [day, month, year] = dateParam.split('/');

                const date = new Date(year, month - 1, day);
                date.setDate(date.getDate() + op);

                const dd = String(date.getDate()).padStart(2, '0');
                const mm = String(date.getMonth() + 1).padStart(2, '0');
                const yyyy = date.getFullYear();

                return `${dd}/${mm}/${yyyy}`;
            },
            setDateFrom(paramDate){
                console.log('/// optionSameDate',this.optionSameDate);
                this.dateFrom = paramDate;
                if(this.optionSameDate) this.dateTo = this.dateFrom;
            },
            initialConfig(){
                
                if (this.isPoliclinica) {
                    this.form.purchases.dateFilterType = 2;
                    this.form.purchases.groupPayments = false;
                    this.form.purchases.includePaid = 
                        this.form.purchases.includeCredit = 
                        this.form.purchases.concatInvoice = true;

                    this.form.sales.returns = true;
                }else if(this.isTecana){
                    this.form.purchases.dateFilterType = 1;
                    this.form.purchases.groupPayments = false;
                    this.form.purchases.includeCosts =
                        this.form.purchases.includeExpenses =
                        this.form.purchases.includePaid = 
                        this.form.purchases.includeCredit = 
                        this.form.purchases.concatInvoice = true;

                    this.form.sales.sales2 = false;
                    this.form.sales.sales4 = 2;
                    this.form.sales.returns = false;
                }
                
            },
            formatedMoneyField( field ) {
                return `${ this.Currency }${ numberWithCommas( this[ field ] ) }`;
            },
            formatedMoneyFieldFromChild( field, obj ) {
                return `${ this.Currency }${ numberWithCommas( obj[ field ] ) }`;
            },
            async getAutomaticEntries(){
                try {
                    this.submittedType = this.type;
                    const requestObj = {
                        type: this.type,
                        dateFrom: convertDateFormat2( this.dateFrom, this.formatConfig, this.targetFormat ),
                        dateTo: convertDateFormat2( this.dateTo, this.formatConfig, this.targetFormat ),
                        ...this.form,
                        concatCustomerLegalName: this.form.sales.value && this.type === 1
                            ? this.concatCustomerLegalName
                            : false
                    };

                    let { data: { executionIds, recordset } } = await this.$API.branchaccountcatalog.automaticAccountingEntries( { ...requestObj } );
                    this.executionIds = executionIds;
                    if(this.type == 1 && this.concatCustomerLegalName == 1 && this.form.sales.value == 1){
                        recordset = recordset.map(element => {
                            if( element.ID_Provider != null || element.ProviderLegalName ) {
                                return element;
                            }

                            const accountDescription = element.account_description ?? '';

                            if( !accountDescription.includes(' |-> ') || !accountDescription.includes(' Cliente. ') ) {
                                return element;
                            }

                            const [ accountDescription1 = '', accountDescription2Raw = '' ] = accountDescription.split(' |-> ');
                            const [ accountDescription2 = '', accountDescription3 = '' ] = accountDescription2Raw.split(' Cliente. ');

                            element.accountDescription1 = accountDescription1;
                            element.accountDescription2 = accountDescription2;
                            element.accountDescription3 = accountDescription3;
                            return element;
                        });
                    }

                    this.DataTable = [ ...recordset ];
                } catch (error) {
                    this.showAlert(
                        "danger",
                        "Error al Ver Movimientos",
                        "Sucedió el siguiente error al consultar movimientos " + error.message
                    );
                } finally {
                    this.loading = false;
                }
            },
            async validateUnassignedElements() {
                this.loading = true;
                try {
                    const requestObj = {
                        type: this.type,
                        dateFrom: convertDateFormat2( this.dateFrom, this.formatConfig, this.targetFormat ),
                        dateTo: convertDateFormat2( this.dateTo, this.formatConfig, this.targetFormat ),
                        ...this.form
                    };

                    const { message, data } = await this.$API.branchaccountcatalog.unassignedAccounts( { ...requestObj } );

                    if( data.length > 0 ) {
                        this.showAlert(
                            "questionHtmlBulkDownload",
                            "Advertencia",
                            "Surgieron las siguientes observaciones al intentar obtener los movimientos del periodo solicitado:<br/><br/>" + message,
                            {
                                filesPools: data,
                                callbackLabel: "getAutomaticEntries"
                                // fileTitle: 'Elementos_sin_cuenta_asignada',
                                // fileData: data,
                            },
                        );
                    } else {
                        await this.validateItemsWithoutAverageCost();
                    }
                } catch (error) {
                    this.showAlert(
                        "danger",
                        "Error al Validar Asignación de Cuentas",
                        "Sucedió el siguiente error al validar la asignación de cuentas dentro del período solicitado " + error.message
                    );
                    this.loading = false;
                }
                
            },
            async validateItemsWithoutAverageCost() {
                this.loading = true;
                try {
                    const requestObj = {
                        type: this.type,
                        dateFrom: convertDateFormat2( this.dateFrom, this.formatConfig, this.targetFormat ),
                        dateTo: convertDateFormat2( this.dateTo, this.formatConfig, this.targetFormat ),
                        ...this.form
                    };

                    const { message, data } = await this.$API.branchaccountcatalog.getProductsWithoutAverageCost( { ...requestObj } );
    
                    if( data.length > 0 ) {
                        this.showAlert(
                            "questionHtmlDownload",
                            "Advertencia",
                            "Se encontraron productos sin costo, se omitirán hasta tener precio de costo. Listado de productos:<br/><br/>" + message,
                            {
                                fileTitle: 'Productos_sin_costo_promedio',
                                fileData: data,
                                callbackLabel: "getAutomaticEntries"
                            },
                        );
                    } else {
                        await this.getAutomaticEntries();
                    }
                } catch (error) {
                    this.showAlert(
                        "danger",
                        "Error al validar si habian productos sin costo promedio dentro del período solicitado",
                        "Sucedió el siguiente error al validar si habian productos sin costo promedio dentro del período solicitado " + error.message
                    );
                    this.loading = false;
                }
            },
            processDetailsBeforeInit() {
                this.showAlert(
                    'questionWithInnerHTML',
                    'Advertencia, Proceso Delicado!',
                    `<p style="color: whitesmoke !important;">
                        El proceso que está a punto de ejecutar debe ser ejecutado con competencia y conciencia de lo que se está haciendo. Si se ejecuta sin tener las consideraciones necesarias podría provocar los siguientes inconvenientes:
                        <ol>
                            <li>Lentitud en el sistema dentro de horas laborales</li>
                            <li>Duplicidad de registros contables</li>
                            <li>Incongruencias y descuadres contables</li>
                        </ol>
                    </p>`,
                    'processDetails'
                );
            },
            async processDetails() {
                this.loading = true;
                try {
                    // throw 'stop';
                    if( !this.validateData() ) {
                        return;
                    }
    
                    let accountingEntriesToInsert;
                    const fromDate = new Date( convertDateFormat2( this.dateFrom, this.formatConfig, this.targetFormat ) );
                    // fromDate.setDate( fromDate.getDate() + 1 );
                    const Period_From = fromDate.toISOString().split('T')[0];
                    const toDate = new Date( convertDateFormat2( this.dateTo, this.formatConfig, this.targetFormat ) );
                    // toDate.setDate( toDate.getDate() + 1 );
                    const Period_To = toDate.toISOString().split('T')[0];
                    let batchSpecification = `Lote de Partidas Automáticas `;
                    batchSpecification += `${ this.type === 1 ? 'Por Movimiento' : 'Por Operación' }, `;
                    batchSpecification += `TIPOS: `;
                    let sales = false;
                    let cost = false;
                    let purchases = false;
                    let payments = false;
                    let provitionsPayments = false;
                    let settlement = false;
                    let provisions_cost = false;
                    let provisions_expense = false;

                    if( this.form.sales.value ) {
                        sales = true;
                        batchSpecification += `VENTA por ${ this.form.sales.sales2 ? 'estado de la factura' : 'método de pago' } |`
                        if( this.form.sales.sales3 ) {
                            cost = true;
                            batchSpecification += ` COSTO DE VENTAS |`;
                        }
                    }

                    if( this.form.purchases.value ) {
                        purchases = true
                        if( this.form.purchases.includeCosts ) {
                            provisions_cost = true;
                            batchSpecification += ` COSTO |`;
                        }
                        if( this.form.purchases.includeExpenses ) {
                            provisions_expense = true;
                            batchSpecification += ` GASTO |`;
                        }
                    }

                    if( this.form.payments.value ) {
                        payments = true
                        batchSpecification += ` ABONOS`;
                        if( this.form.payments.groupByPaymentMethods ) {
                            batchSpecification += ` POR MÉTODO DE PAGO`;
                        } else {
                            batchSpecification += ` COMO INGRESOS POR ABONOS`
                        }

                        if( this.form.payments.creditsAdditionStyle ) {
                            batchSpecification += ` SEGÚN PARAMETRIZACIÓN GENERAL`
                        } else {
                            batchSpecification += ` SEGÚN PARAMETRIZACIÓN DEL CLIENTE`
                        }
                        batchSpecification += ` |`
                    }

                    if( this.form.provitionsPayments.value ) {
                        provitionsPayments = true
                        batchSpecification += ` ABONOS A PROVEEDORES`;
                        if( this.form.provitionsPayments.groupByPaymentMethods ) {
                            batchSpecification += ` POR MÉTODO DE PAGO`;
                        } else {
                            batchSpecification += ` COMO INGRESOS POR ABONOS`
                        }

                        if( this.form.provitionsPayments.creditsAdditionStyle ) {
                            batchSpecification += ` SEGÚN PARAMETRIZACIÓN GENERAL`
                        } else {
                            batchSpecification += ` SEGÚN PARAMETRIZACIÓN DEL CLIENTE`
                        }
                        batchSpecification += ` |`
                    }

                    if( this.form.settlement.value ) {
                        settlement = true;
                        batchSpecification += `CIERRE incluyendo: `;
                        if( this.form.settlement.includeOI ) {
                            batchSpecification += `INGRESOS OPERACIONALES |`;
                        }
                        if( this.form.settlement.includeANOI ) {
                            batchSpecification += `INGRESOS NO OPERACIONALES |`;
                        }
                        if( this.form.settlement.includeCRAS ) {
                            batchSpecification += `COSTOS, DEVOLUCIONES Y REBAJAS SOBRE VENTAS |`;
                        }
                        if( this.form.settlement.includeSpents ) {
                            batchSpecification += `GASTOS |`;
                        }
                    }

                    batchSpecification = batchSpecification.substring( 0, batchSpecification.length - 1 );

                    if( this.type === 2 ) {
                        accountingEntriesToInsert = this.accountingEntriesByOp();
                    }
                    else if( this.type === 1 ) {
                        accountingEntriesToInsert = this.accountingEntriesByDocument();
                    }
                    await this.$API.accountingentryheader.bulkCreateAccountingEntryHeader( {
                        data: {
                            accountingEntriesToInsert,
                            type: this.type,
                            Period_From,
                            Period_To,
                            settlementYear: this.form.settlement.year,
                            batchSpecification,
                            sales,
                            cost,
                            purchases,
                            provisions_cost,
                            provisions_expense,
                            payments,
                            provitionsPayments,
                            settlement,
                            executionIds: this.executionIds
                        },
                        params: {
                            dateFilter_dateStart: Period_From,
                            dateFilter_dateEnd: Period_To,
                            dateFilter_type: 1,
                            settlementYear: this.form.settlement.year,
                            sales,
                            cost,
                            purchases,
                            provisions_cost,
                            provisions_expense,
                            payments,
                            provitionsPayments,
                            settlement
                        }
                    } );

                    this.showAlert(
                        "success",
                        `Periodo de ${ this.dateFrom } a ${ this.dateTo } Procesado Correctamente`,
                        `Se han insertado las partidas contables del período DE ${ this.dateFrom } A ${ this.dateTo }`
                    );
                } catch (error) {
                    this.showAlert(
                        "danger",
                        "Error al Contabilizar",
                        "Hubo un problema al intentar contabilizar los movimientos del periodo solicitado. " + error.message
                    );
                } finally {
                    this.loading = false;
                }

            },
            accountingEntriesByOp() {
                const ops = this.DataTable.map( current => {
                    const { Op } = current
                    return Op;
                } );
                const uniqueOps = ops.filter( onlyUnique );
                const opsObj = {};
                // const now = new Date().toISOString().split('T')[0];

                for( const op of uniqueOps ) {
                    const filteredDetails = this.DataTable.filter( current => {
                        const { Op } = current;
                        return Op === op;
                    } );

                    const toDate = new Date( convertDateFormat2( this.dateTo, this.formatConfig, this.targetFormat ) );
                    // toDate.setDate( toDate.getDate() + 1 );

                    opsObj[ op ] = {};
                    opsObj[ op ].header = {
                        id_accounting_entry_type: this.accounting_entry_types[ op ],
                        accounting_entry_date: toDate.toISOString().split('T')[0],
                        accounting_entry_comment:
                            op === 'Cierre'
                                ? `Partida automática de ${ op } del período ${ this.form.settlement.year }`
                                : `Partida automática de ${ op }, PERIODO: de ${ convertDateFormat2( this.dateFrom, this.formatConfig, this.targetFormat ) } a ${ convertDateFormat2( this.dateTo, this.formatConfig, this.targetFormat ) }`
                        ,
                        accounting_entry_value: parseFloat(
                            filteredDetails.reduce(
                                ( acc, current ) => {
                                    const { Amount, id_entry_detail_type } = current;
                                    return id_entry_detail_type === 1 ? acc + parseFloat( Amount ) : acc ;
                                },
                                0
                            ).toFixed( 2 )
                        )
                    };
                    
                    opsObj[ op ].details = filteredDetails.map( current => {
                        const {
                            id_account,
                            id_entry_detail_type,
                            Amount: amount
                        } = current;

                        let {
                            account_description: concept
                        } = current;

                        if( concept.includes( ' |-> ' ) ) {
                            const [ , customConcept ] = concept.split( ' |-> ' );

                            concept = customConcept;
                        }

                        return {
                            id_account,
                            id_entry_detail_type,
                            amount: amount.toFixed( 2 ),
                            concept
                        };
                    } );
                }

                return opsObj;
            },
            accountingEntriesByDocument() {
                const ops = this.DataTable.map( current => {
                    const { Op } = current
                    return Op;
                } );
                const documents = this.DataTable.map( current => {
                    const { ID_Invoice } = current
                    return ID_Invoice;
                } );
                const uniqueOps = ops.filter( onlyUnique );
                const uniqueDocuments = documents.filter( onlyUnique );
                const documentsObj = {};

                for( const op of uniqueOps ) {
                    const filteredOps = this.DataTable.filter( current => {
                        const { Op } = current;
                        return Op === op;
                    } );

                    documentsObj[ op ] = {};
                    for( const invoice of uniqueDocuments ) {
                        const filteredDetails = filteredOps.filter( current => {
                            const { ID_Invoice } = current;
                            return ID_Invoice === invoice;
                        } );

                        if( filteredDetails.length > 0 ) {
                            const toDate = new Date( convertDateFormat2( this.dateTo, this.formatConfig, this.targetFormat ) );
                            // toDate.setDate( toDate.getDate() + 1 );

                            documentsObj[ op ][ invoice ] = {};
                            documentsObj[ op ][ invoice ].header = {
                                id_accounting_entry_type: this.accounting_entry_types[ op ],
                                accounting_entry_date: toDate.toISOString().split('T')[0],
                                accounting_entry_comment:
                                    op === 'Cierre'
                                        ? `Partida automática de ${ op } del período ${ this.form.settlement.year }`
                                        : `Partida automática de ${ op } del documento ${ invoice }, PERIODO: de ${ convertDateFormat2( this.dateFrom, this.formatConfig, this.targetFormat ) } a ${ convertDateFormat2( this.dateTo, this.formatConfig, this.targetFormat ) }`,
                                accounting_entry_value: parseFloat(
                                    filteredDetails.reduce(
                                        ( acc, current ) => {
                                            const { Amount, id_entry_detail_type } = current;
                                            // console.log( 'id_entry_detail_type ', id_entry_detail_type, current )
                                            return id_entry_detail_type === 1 ? acc + parseFloat( Amount ) : acc ;
                                        },
                                        0
                                    ).toFixed( 2 )
                                ),
                                accounting_entry_invoice_reference: invoice
                            };
                            
                            documentsObj[ op ][ invoice ].details = filteredDetails.map( current => {
                                const {
                                    id_account,
                                    id_entry_detail_type,
                                    Amount: amount
                                } = current;

                                let {
                                    account_description: concept
                                } = current;

                                if( concept.includes( ' |-> ' ) ) {
                                    const [ , customConcept ] = concept.split( ' |-> ' );

                                    concept = customConcept;
                                }
                                return {
                                    id_account,
                                    id_entry_detail_type,
                                    amount: amount.toFixed( 2 ),
                                    concept
                                };
                            } );
                        }
                    }
                }
                return documentsObj;
            },
            validateData() {
                if( this.DataTable?.length > 0 ) {
                    return true;
                } else {
                    return false;
                }
            },
            closeAlert() {
                this.alert.show = false;
                this.loading = false;
            },
            acceptAlert() {
                this.alert.show = false;
                if( this.alert.options ) {

                    const callbackLabel =
                        typeof this.alert.options === 'object'
                            ? this.alert.options.callbackLabel
                            : this.alert.options;
                    
                    this[ callbackLabel ]();
                }
            },
            showAlert(type, header, body, options = null) {
                type = type == null ? "danger" : type;
                this.alert.type = type;
                this.alert.header = header;
                this.alert.body = body;
                this.alert.show = true;
                this.alert.options = options != null ? options : null;

                //console.log( this.alert );
                // try {
                    
                // } catch (error) {
                //     console.log( 'showAlert ', error )
                // }
            },
           
        },

    }
</script>

<style scoped>
.bar {
  width: 100%;
  background-color: rgb(60, 60, 60) !important;
  color: white !important;
  border-style: solid;
  border-color: black;
  border-radius: 15px !important;
  margin-top: 1rem !important;
}
.btn-add{
  background-color: #3498DB  !important;
  color: white;
}
.btnsave{
  background-color: #00A178 !important;
  color: white;
}
.btnclean{
  background-color: #F29D35 !important;
  color: white;
}
.btndelete{
  background-color: #E3191E !important;
  color: white;
}

.grid-invisible {
  position: absolute !important;
  top: -9999px !important;
  left: -9999px !important;
  width: 1200px !important;
  height: 600px !important;
  visibility: hidden !important;
}
</style>
